export default "__VITE_ASSET__ZD2Pd197__"